
/*
 *  Karussell für snippets/Product-Tiles.liquid
 *
 *  Die Liste scrollt nativ ( scroll-snap , wischen auf Touch ) ,
 *  Pfeile und Punkte blättern seitenweise. Kacheln dürfen später
 *  eingefügt werden ( Zuletzt angesehen ) , alles passt sich an.
 *
 *  data-autoplay : Sekunden , leer = aus
 *  data-loop : am Ende wieder von vorne
 */

class Component
extends HTMLElement {

    connectedCallback (){

        this.list = this.querySelector('[data-product-tiles-list]')
        this.prev = this.querySelector('[data-carousel-prev]')
        this.next = this.querySelector('[data-carousel-next]')
        this.dots = this.querySelector('[data-carousel-dots]')

        this.loop = this.hasAttribute('data-loop')
        this.autoplay = Number(this.dataset.autoplay) || 0

        this.prev?.addEventListener('click',() => this.step(-1) )
        this.next?.addEventListener('click',() => this.step(1) )

        this.list.addEventListener('scroll',() => this.onScroll() ,{ passive : true })

        this.resizeObserver = new ResizeObserver(() => this.update() )
        this.resizeObserver.observe(this.list)

        this.mutationObserver = new MutationObserver(() => this.update() )
        this.mutationObserver.observe(this.list,{ childList : true })

        //  Autoplay pausiert bei Hover , Fokus und wenn nicht sichtbar

        this.paused = false
        this.visible = false

        if( this.autoplay && ! matchMedia('(prefers-reduced-motion: reduce)').matches ){

            const pause = () => { this.paused = true }
            const resume = () => { this.paused = false }

            this.addEventListener('mouseenter',pause)
            this.addEventListener('mouseleave',resume)
            this.addEventListener('focusin',pause)
            this.addEventListener('focusout',resume)
            this.list.addEventListener('touchstart',pause,{ passive : true })

            this.intersectionObserver = new IntersectionObserver(( [ entry ] ) => {
                this.visible = entry.isIntersecting
            })

            this.intersectionObserver.observe(this)

            this.timer = setInterval(() => {
                if( this.visible && ! this.paused && document.visibilityState === 'visible' )
                    this.step(1,true)
            },this.autoplay * 1000)
        }

        this.update()
    }

    disconnectedCallback (){
        clearInterval(this.timer)
        this.resizeObserver?.disconnect()
        this.mutationObserver?.disconnect()
        this.intersectionObserver?.disconnect()
    }

    get items (){
        return [ ... this.list.children ]
    }

    //  Anzahl Kacheln , die gleichzeitig ganz sichtbar sind

    get perPage (){

        const [ first , second ] = this.items

        if( ! first )
            return 1

        const stride = second
            ? second.offsetLeft - first.offsetLeft
            : first.offsetWidth

        return Math.max(1,Math.floor(( this.list.clientWidth + 1 ) / stride ))
    }

    get pageCount (){
        return Math.max(1,Math.ceil(this.items.length / this.perPage))
    }

    get maxScroll (){
        return this.list.scrollWidth - this.list.clientWidth
    }

    get currentPage (){

        if( this.list.scrollLeft >= this.maxScroll - 2 )
            return this.pageCount - 1

        const [ first , second ] = this.items

        if( ! first )
            return 0

        const stride = second ? second.offsetLeft - first.offsetLeft : first.offsetWidth

        return Math.round(this.list.scrollLeft / stride / this.perPage)
    }

    goTo ( page ){

        const index = Math.min(page * this.perPage,this.items.length - 1)
        const item = this.items[ index ]

        if( ! item )
            return

        const left = item.offsetLeft - this.items[ 0 ].offsetLeft

        this.list.scrollTo({ left : Math.min(left,this.maxScroll) })
    }

    step ( direction , fromAutoplay = false ){

        const count = this.pageCount
        let page = this.currentPage + direction

        if( page >= count )
            page = ( this.loop || fromAutoplay ) ? 0 : count - 1

        if( page < 0 )
            page = this.loop ? count - 1 : 0

        this.goTo(page)
    }

    onScroll (){
        cancelAnimationFrame(this.frame)
        this.frame = requestAnimationFrame(() => this.updateState() )
    }

    update (){

        const scrollable = this.maxScroll > 2

        this.toggleAttribute('data-scrollable',scrollable)

        if( this.dots ){

            const count = scrollable ? this.pageCount : 0

            if( this.dots.children.length !== count ){

                this.dots.replaceChildren(... Array.from({ length : count },( _ , page ) => {

                    const dot = document.createElement('button')

                    dot.type = 'button'
                    dot.className = 'product-tiles__dot'
                    dot.setAttribute('aria-label',`Seite ${ page + 1 } von ${ count }`)
                    dot.addEventListener('click',() => this.goTo(page) )

                    return dot
                }))
            }
        }

        this.updateState()
    }

    updateState (){

        const scrollable = this.maxScroll > 2
        const left = this.list.scrollLeft

        if( this.prev )
            this.prev.disabled = ! scrollable || ( ! this.loop && left <= 2 )

        if( this.next )
            this.next.disabled = ! scrollable || ( ! this.loop && left >= this.maxScroll - 2 )

        if( this.dots ){

            const current = this.currentPage

            for ( const [ page , dot ] of [ ... this.dots.children ].entries() )
                dot.setAttribute('aria-current',String(page === current))
        }
    }
}


if( ! customElements.get('product-carousel') )
    customElements.define(
        'product-carousel' ,
        Component
    )
